import * as actions from 'actions/feature/snapshots'
import { Map } from 'immutable'
import { set } from 'utils/immutable'

export default {
  [actions.FEATURE_SNAPSHOTS_RECEIVED]: getFeatureSnapshots,
}

function getFeatureSnapshots(state, payload) {
  const { data } = payload
  const {
    entities: { snapshots },
  } = data
  return set('snapshots', snapshots || Map(), state)
}
